import { render, staticRenderFns } from "./pricingTwo.vue?vue&type=template&id=1f86aaf4&"
import script from "./pricingTwo.vue?vue&type=script&lang=js&"
export * from "./pricingTwo.vue?vue&type=script&lang=js&"
import style0 from "./pricingTwo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports